import { render, staticRenderFns } from "./SpecialtiesSelect.vue?vue&type=template&id=009ef821&scoped=true"
import script from "./SpecialtiesSelect.vue?vue&type=script&lang=js"
export * from "./SpecialtiesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ef821",
  null
  
)

export default component.exports